<style scoped>
  @import '/static/css/welcome.css';
</style>

<template>
  <div>
    <div class="header">
      <span class="logo"></span>
      <button id="gonow" class="header-button">立即体验</button>
      <span class="header-login">登录</span>
    </div>
    <div id="banner_tabs" class="flexslider">
      <ul class="slides">
        <li>
          <a title="" href="javascript:;">
            <img src="/static/images/app/banner_a-2.png" width="100%" height='100%'>
          </a>
        </li>
        <li>
          <a title="" href="javascript:;">
            <img src="/static/images/app/banner_b-2.png" width="100%" height='100%'>
          </a>
        </li>
        <li>
          <a title="" href="javascript:;">
            <img src="/static/images/app/banner_c-2.png" width="100%" height='100%'>
          </a>
        </li>
      </ul>
      <ol id="bannerCtrl" class="flex-control-nav flex-control-paging">
        <li><a>1</a></li>
        <li><a>2</a></li>
        <li><a>2</a></li>
      </ol>
    </div>
    <div class="introduction">人工智能和大数据技术驱动的投研首选平台</div>
     <div class="transit"></div>
     <div class="search-style">
      <span class="search-style-text"></span>
      <span class="search-style-pic"></span>
      <ul class="search-style-fixed">
        <li>
          <div class="triangle-f"><img src="/static/images/app/Triangle.png" alt=""></div>
          <div class="triangle-text">提供对A股、新三板、债券等市场的公开信息披露搜索</div>
        </li>
        <li>
          <div class="triangle-f"><img src="/static/images/app/Triangle.png" alt=""></div>
          <div class="triangle-text">提供对证监会、投资者和企业间问答内容的搜索（独家仅有）</div>
        </li>
        <li>
          <div class="triangle-f"><img src="/static/images/app/Triangle.png" alt=""></div>
          <div class="triangle-text">支持对指定公司、行业、公告类型、市场板块的定向搜索</div>
        </li>
        <li>
          <div class="triangle-f"><img src="/static/images/app/Triangle.png" alt=""></div>
          <div class="triangle-text">搜索关键词可按照“和、或、非”的关系任意组合</div>
        </li>
      </ul>
    </div>
    <div class="transit"></div>
    <div class="advsearch-style">
      <span class="advsearch-style-text"></span>
      <span class="advsearch-style-pic"></span>
      <ul class="advsearch-style-fixed">
        <li>
          <div class="triangle-f"><img src="/static/images/app/Triangle.png" alt=""></div>
          <div class="triangle-text">可从行业、注册地址、财务数据等多个维度叠加限制条件，搜索指定公司</div>
        </li>
        <li>
          <div class="triangle-f"><img src="/static/images/app/Triangle.png" alt=""></div>
          <div class="triangle-text">可从公告类型、公告标题、章节标题等多个维度叠加限制条件，搜索指定内容</div>
        </li>
        <li>
          <div class="triangle-f"><img src="/static/images/app/Triangle.png" alt=""></div>
          <div class="triangle-text">各种条件可以层层叠加，实现精准搜索效果</div>
        </li>
      </ul>
      <div class="they-all-use"></div>
    </div>
    <div class="users"></div>
    <div class="bottom"></div>
    <div class="cover"></div>
    <div class="alertPage">
      <div class="alertPage-text">①获取内测邀请码</div>
      <div class="jieshao">即刻添加尽调小助手的微信，领取邀请码</div>
      <div class="jieshao">免费体验年费过万的超强金融搜索引擎和智能分析工具</div>
      <div class="erweima"></div>
      <div class="alertPage-text">②前往<a href="http://www.ibdata.cn/#!/">www.ibdata.cn</a>注册</div>
    </div>
  </div>
</template>


<script>
import $ from 'jquery'

export default {
  name: 'WelcomeView',
  data(){
    return{

    }
  },
  created () {
    document.addEventListener('DOMContentLoaded', function(e) {
      document.getElementsByTagName('html')[0].style.fontSize = window.innerWidth * (28 / 480) + 'px';
    }, false);
    var Slider = function(container, options) {
      /*
      options = {
          auto: true,
          time: 3000,
          event: 'hover' | 'click',
          mode: 'slide | fade',
          controller: $(),
          activeControllerCls: 'className',
          exchangeEnd: $.noop
      }
      */

      "use strict"; //stirct mode not support by IE9-

      if (!container) return;
      var options = options || {},
        currentIndex = 0,
        cls = options.activeControllerCls,    //acitive class名
        delay = options.delay,                // delay 轮播延迟的时间
        isAuto = options.auto,                // true
        controller = options.controller,      // 圆点按钮
        event = options.event,                // hover
        interval,
        slidesWrapper = container.children().first(),  // 第一个孩子节点 ul
        slides = slidesWrapper.children(),             // 孩子的孩子节点 3个li
        length = slides.length,                        // 孩子节点的长度 3
        childWidth = container.width(),                // 图片的宽度  375
        totalWidth = childWidth * slides.length;      // 图片总长度   1125

      function init() {        
        var controlItem = controller.children();  // 圆点按钮
        mode();     // 初始化  第一个图片显示， 兄弟节点隐藏
        if(event == 'hover'){     
            $(controlItem).mouseover(function() {
            stop();
            var index = $(this).index();
            play(index, options.mode);
          }).mouseout(function() {
            console.log("出了图片范围")
            isAuto && autoPlay();
          })
        } else {
          controlItem.click(function() {
          stop();
          var index = $(this).index();

          play(index, options.mode);
          isAuto && autoPlay();
        });
       }
        isAuto && autoPlay();
      }

      //animate mode
      function mode() {
        var wrapper = container.children().first();

        options.mode == 'slide' ? wrapper.width(totalWidth) : wrapper.children().css({
            'position': 'absolute',
            'left': 0,
            'top': 0
          })
          .first().siblings().hide();
      }

      //auto play
      function autoPlay() {
        interval = setInterval(function() {
          triggerPlay(currentIndex);
        }, options.time);
      }

      //trigger play
      function triggerPlay(cIndex) {
        var index;

        (cIndex == length - 1) ? index = 0: index = cIndex + 1;
        play(index, options.mode);
      }

      //play
      function play(index, mode) {
        slidesWrapper.stop(true, true);
        slides.stop(true, true);

        mode == 'slide' ? (function() {
          if (index > currentIndex) {
            slidesWrapper.animate({
              left: '-=' + Math.abs(index - currentIndex) * childWidth + 'px'
            }, delay);
          } else if (index < currentIndex) {
            slidesWrapper.animate({
              left: '+=' + Math.abs(index - currentIndex) * childWidth + 'px'
            }, delay);
          } else {
            return;
          }
        })() : (function() {
          if (slidesWrapper.children(':visible').index() == index) return;
          slidesWrapper.children().fadeOut(delay).eq(index).fadeIn(delay);
        })();

        try {
          controller.children('.' + cls).removeClass(cls);
          controller.children().eq(index).addClass(cls);
        } catch (e) {}

        currentIndex = index;

        options.exchangeEnd && typeof options.exchangeEnd == 'function' && options.exchangeEnd.call(this, currentIndex);
      }

      //stop
      function stop() {
        clearInterval(interval);
      }

      //prev frame
      function prev() {
        stop();

        currentIndex == 0 ? triggerPlay(length - 2) : triggerPlay(currentIndex - 2);

        isAuto && autoPlay();
      }

      //next frame
      function next() {
        stop();

        currentIndex == length - 1 ? triggerPlay(-1) : triggerPlay(currentIndex);

        isAuto && autoPlay();
      }

      //init
      init();

      //expose the Slider API
      return {
        prev: function() {
          prev();
        },
        next: function() {
          next();
        }
      }
    };
    $(function(){   
    var bannerSlider = new Slider($('#banner_tabs'), {
      time: 1500,
      delay: 400,
      event: 'hover',
      auto: true,
      mode: 'fade',
      controller: $('#bannerCtrl'),
      activeControllerCls: 'active'
    });
      // 获取屏幕高度
    var height = $(document).height()
    $('#gonow').click(function() {
      $(".cover").css("height", height + "px");
      $('.alertPage').css("display", "block");
    });
    $(".cover").click(function() {
      $('.cover').css("height", "0");
      $('.alertPage').css("display", "none");
    })
    });
  }
}
</script>



/** WEBPACK FOOTER **
 ** Welcome.vue?2671ad28
 **/